export default {
  'menu.welcome': 'ホーム',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.login': 'ログイン',
  'menu.register': '登録',
  'menu.register-result': '登録結果',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.settings': 'アカウント設定',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',

  // システム設定
  'menu.system.settings': 'システム設定',
  'menu.system.settings.role-management': 'ロール管理',
  'menu.system.settings.page-auth-management': '画面権限管理',
  'menu.system.settings.account-roles-management': 'アカウントロール設定',
  'menu.system.settings.account-management': 'アカウント管理',
  'menu.system.settings.profile-settings': 'プロファイル設定',
  'menu.system.settings.feedback-management': '更新情報・フィードバック',

  //　総務部メニュー
  'menu.general.affairs': '総務部',
  'menu.general.affairs.attendance-input-onsite': '考勤录入（现场项目）',
  'menu.general.affairs.attendance-input-training': '考勤录入（社内研修）',
  'menu.general.affairs.attendance-list-onsite': '勤怠一覧（现场项目）',
  'menu.general.affairs.attendance-list-training': '勤怠一覧（社内研修）',
  'menu.general.affairs.commute-commit': '通勤費申請',
  'menu.general.affairs.commute-commit-list': '通勤費申請一覧',
  'menu.general.affairs.oa-requests': '休暇申請',
  'menu.general.affairs.oa-approvals': '休暇承認',
  'menu.general.affairs.oa-workflows': '休暇承認フロー',
  'menu.general.affairs.fixed-assets': '固定資産管理',

  // 人事部メニュー
  'menu.human.resources': '人事部',
  'menu.human.resources.employee-personal-update': '社員情報更新',
  'menu.human.resources.dashboard': 'ダッシュボード',
  'menu.human.resources.employee-list-trainee': '研修情報一覧',
  'menu.human.resources.employee-list-regular': '社員情報一覧',
  'menu.human.resources.employee-list-bp': 'BP社員情報一覧',
  'menu.human.resources.employee-list-undefined': '未定情報一覧',
  'menu.human.resources.employee-info-init': '社員情報更新',
  'menu.human.resources.interview-list': '面接情報一覧',
  'menu.human.resources.document-requests': '書類申請',
  'menu.human.resources.document-request-management': '書類申請管理',

  // 開発部メニュー
  'menu.development': '開発部',
  'menu.development.learn-analytics': '研修データ分析',
  'menu.development.learn-progress': '受講者進捗一覧',
  'menu.development.learn-course': 'コース管理',
  'menu.development.learn-player': '受講・テスト',
  'menu.development.stage-exam': '段階考査',
  'menu.development.learn-test': 'テストページ',
  'menu.development.learn-question': '質問ページ',

  // 営業部
  'menu.sales': '営業部',
  'menu.sales.bp-list': '協力会社一覧',
  'menu.sales.bp-sales-list': 'BP営業一覧',
  'menu.sales.internal-sales-list': '社内営業一覧',
  'menu.sales.invoice-list': '請求書一覧',
  'menu.accounting': '経理部',
  'menu.accounting.dashboard': 'ダッシュボード',
  'menu.accounting.salary-management': '給与管理',
  'menu.internal-notices': '社内公示・お知らせ',
  'menu.system.settings.internal-notices': '社内公示・お知らせ管理',
};
